import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('cacmModule')
        .controller('CacmController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'searchV2Service', 'selectionService', 'historyCtxtService', 'cacmService', 'modalService'];

    function Controller($scope, $state, topBarService, searchV2Service, selectionService, historyCtxtService, cacmService, modalService) {

        topBarService.setTitleAndIcon('CACM', 'fa fa-bullseye');

        $scope.ctrlCtxt = {
          environment: environment
        };

        // Limit defined in GovConfiguration in the BE
        // TODO Use an endpoint to read value from the BE
        var cacmEventExportLimit = 10000;

        $scope.cacmEventSelectionService = selectionService.init('event', 'events', groupEvents, groupCreated, fetchCompatibleGroups, addToGroup, groupCreated);

	    searchV2Service
		    .initializeSearch(
		        ['CACMEvent', 'CACMControl', 'CACMDynamicsAccountTransaction', 'CACMConcurExpense'],
                $state.params)
            .then(function (searchCtxt) {
                $scope.ctrlCtxt.searchCtxt = searchCtxt;
            });

        $scope.goToEvent = function (event) {
            if ($scope.cacmEventSelectionService && $scope.cacmEventSelectionService.selectionMode) return;

            historyCtxtService.goToState('cacmEditEvent',
                { CACMEventID: event.CACMEventID },
                $state.current.name
            );
        };

        $scope.goToControl = function (control) {
            historyCtxtService.goToState('control',
                { ControlID: control.ControlID },
                $state.current.name
            );
        };

	    $scope.exportToExcelGL = exportToExcelGL;
	    $scope.exportToExcelConcur = exportToExcelConcur;

        function groupEvents(message, eventIdList) {
            return cacmService.groupEvents(message, eventIdList).then(function (groupId) {
                return groupId;
            });
        }

        function groupCreated(group) {
            if (group && group.CACMEventID) {
                historyCtxtService.goToState('cacmEditEvent',
                    { CACMEventID: group.CACMEventID },
                    $state.current.name
                );
            }
        }

        function fetchCompatibleGroups(selectedEventIds) {
            return cacmService.getCompatibleGroups(selectedEventIds[0]);
        }

        function addToGroup(group, items) {
            return cacmService.addEventsToGroup(group.CACMEventID, items);
        }

        function exportToExcelGL(bypassConfirmation) {
            var sourceType = 'CACMDynamicsAccountTransaction';
            var numResults = _
                .chain($scope.ctrlCtxt.searchCtxt)
                .get('sources', [])
                .find({sourceType: sourceType})
                .get('searchResponse.response.numFound', 0)
                .value();

            if (!bypassConfirmation && numResults > cacmEventExportLimit) {
                // Display warning
                modalService.displayTemplateModal(
                    'Warning',
                    require('./cacmExportWarning.modal.tpl.html'),
                    {
                        numResults: numResults,
                        limitExport: cacmEventExportLimit,
                        modernStyle: true,
                        okText: 'Export',
                        cancelText: 'Cancel',
                        ngStyle: {
                            'min-height': 0,
                            width: '400px'
                        }
                    },
                    function() {
                        $scope.exportToExcelGL(true);
                        return true;
                    },
                    true
                );
                return;
            }

        	var sourceTypeConfig = searchV2Service.getSourceTypeConfig(sourceType);
        	var queryParams = searchV2Service.getQueryParams(sourceTypeConfig);

        	var queryString = $.param(queryParams, true);
            var urlToDownload = environment.apiUrl + '/Pilot/api/CACM/DynamicsAccountTransaction/ExportToExcel?' +
								queryString;
	        var form = angular.element(document.querySelector('#toDownload'));
	        form.context.action = urlToDownload;
	        form.submit();
        }

	    function exportToExcelConcur(bypassConfirmation) {
            var sourceType = 'CACMConcurExpense';
            var numResults = _
                .chain($scope.ctrlCtxt.searchCtxt)
                .get('sources', [])
                .find({sourceType: sourceType})
                .get('searchResponse.response.numFound', 0)
                .value();

            if (!bypassConfirmation && numResults > cacmEventExportLimit) {
                // Display warning
                modalService.displayTemplateModal(
                    'Warning',
                    require('./cacmExportWarning.modal.tpl.html'),
                    {
                        numResults: numResults,
                        limitExport: cacmEventExportLimit,
                        modernStyle: true,
                        okText: 'Export',
                        cancelText: 'Cancel',
                        ngStyle: {
                            'min-height': 0,
                            width: '400px'
                        }
                    },
                    function() {
                        $scope.exportToExcelConcur(true);
                        return true;
                    },
                    true
                );
                return;
            }

	    	var sourceTypeConfig = searchV2Service.getSourceTypeConfig(sourceType);
		    var queryParams = searchV2Service.getQueryParams(sourceTypeConfig);

		    var queryString = $.param(queryParams, true);
		    var urlToDownload = environment.apiUrl + '/Pilot/api/CACM/ConcurExpense/ExportToExcel?' +
			    queryString;
		    var form = angular.element(document.querySelector('#toDownload'));
		    form.context.action = urlToDownload;
		    form.submit();
	    }
    }
})();
